import { useEffect, useState } from 'react';

import { DEFAULT_RECURRING_RULE } from '@/constants';
import Input from '@/components/Inputs';
import { useForm } from '@/hooks';

const CreateRecurringRuleModal = ({ show, onClose, onSave }) => {
  const [errors, setErrors] = useState(null);
  const [formValues, handleFormChange, setFormValues] = useForm({
    ...DEFAULT_RECURRING_RULE,
  });

  useEffect(() => {
    setFormValues({ ...DEFAULT_RECURRING_RULE });
  }, [show]);
  const handleChange = (event) => {
    handleFormChange(event);
  };

  const onSaveClicked = () => {
    setErrors('');
    if (!formValues.description) {
      setErrors('Description is required');
      return;
    }
    if (!formValues.delay_in_days) {
      setErrors('Delay in Days is required');
      return;
    }
    if (!formValues.template_id) {
      setErrors('Template ID is required');
      return;
    }

    const newValues = {};
    Object.keys(formValues).forEach((key) => {
      if (key.startsWith('react-select')) {
        return;
      }

      newValues[key] = formValues[key];
    });

    onSave(newValues);
  };

  return show ? (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between py-2 px-5 border-b border-solid border-blueGray-200 rounded-t">
              <h3 className="text-lg font-semibold">Add Recurring Rule</h3>
            </div>
            {/*body*/}
            <div className="relative p-6 flex-auto">
              <form
                className="w-full flex flex-col space-y-2"
                onChange={handleChange}
              >
                <div className="flex space-x-4">
                  <div className="w-2/3">
                    <Input
                      type="text"
                      label="Description"
                      id="description"
                      value={formValues?.description || ''}
                      onChange={() => {}}
                    />
                  </div>
                </div>
                <div className="flex space-x-4">
                  <Input
                    type="text"
                    label="Delay In Days"
                    id="delay_in_days"
                    value={formValues?.delay_in_days || ''}
                    onChange={() => {}}
                  />
                  <Input
                    type="text"
                    label="Template ID from Brevo"
                    id="template_id"
                    value={formValues?.template_id || ''}
                    onChange={() => {}}
                  />
                </div>
                {errors && (
                  <div className="p-4 bg-red-50 text-red-900 font-semibold rounded-xl">
                    {errors}
                  </div>
                )}
              </form>
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
              <button
                className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                type="button"
                onClick={onClose}
              >
                Close
              </button>
              <button
                className="button button-primary"
                type="button"
                onClick={onSaveClicked}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  ) : null;
};

export default CreateRecurringRuleModal;
